window.Vivense = window.Vivense || {};

Vivense.cookie = (function($) {

    var exports = {};

    function getCookie(name){
        var cookies = document.cookie ? document.cookie.split('; ') : [];

        for (var i = 0; i < cookies.length; i++){
            var parts = cookies[i].trim().split('=');
            if (parts.length === 2 && parts[0] === name){
                return parts[1].trim();
            }
        }

        return null;
    }

    function setCookie(name, value, expiryHours, path){

        if (name !== undefined && name.length > 0 && value !== undefined){
            var date = new Date();
            var cookieString = name + "=" + value;

            if (expiryHours !== undefined && expiryHours > 0){
                date.setMilliseconds(date.getMilliseconds() + expiryHours * 3600 * 1000);

                cookieString += "; expires=" + date.toUTCString();
            }

            if (path !== undefined && path.length > 0){
                cookieString += "; path=" + path;
            } else {
                cookieString += "; path=/";
            }

            document.cookie = cookieString;
        }

    }

    function cookieExist(name){
        return getCookie(name) != null;
    }

    function deleteCookie(name){
        setCookie(name, '', 0);
    }

    exports.get = getCookie;
    exports.set = setCookie;
    exports.exist = cookieExist;
    exports.delete = deleteCookie;

    return exports;
})(jQuery);